import { TimespanType_Day, TimespanType_Hour, TimespanType_Minute, TimespanType_Month, TimespanType_Second, TimespanType_Week, TimespanType_Year } from './types.js';
import { Day, Hour, Minute, Month, Second, Week, Year } from '@nu-art/ts-common';
export const TimespanLabelsMap = {
    [TimespanType_Second]: 'Seconds',
    [TimespanType_Minute]: 'Minutes',
    [TimespanType_Hour]: 'Hours',
    [TimespanType_Day]: 'Days',
    [TimespanType_Week]: 'Weeks',
    [TimespanType_Month]: 'Months',
    [TimespanType_Year]: 'Years',
};
export const TimespanToValue = {
    [TimespanType_Second]: Second,
    [TimespanType_Minute]: Minute,
    [TimespanType_Hour]: Hour,
    [TimespanType_Day]: Day,
    [TimespanType_Week]: Week,
    [TimespanType_Month]: Month,
    [TimespanType_Year]: Year,
};
//# sourceMappingURL=consts.js.map